import avatarModule from '../avatarModule';

const avatarAssetTypeNames = {
  hat: 'Hat',
  hairAccessory: 'Hair Accessory',
  faceAccessory: 'Face Accessory',
  neckAccessory: 'Neck Accessory',
  shoulderAccessory: 'Shoulder Accessory',
  frontAccessory: 'Front Accessory',
  backAccessory: 'Back Accessory',
  waistAccessory: 'Waist Accessory',
  climbAnimation: 'Climb Animation',
  fallAnimation: 'Fall Animation',
  jumpAnimation: 'Jump Animation',
  runAnimation: 'Run Animation',
  swimAnimation: 'Swim Animation',
  walkAnimation: 'Walk Animation',
  emoteAnimation: 'Emote Animation'
};

const avatarBodyPartIds = [
  27,
  28,
  29,
  30,
  31
];

avatarModule.constant('avatarAssetTypeNames', avatarAssetTypeNames);
avatarModule.constant('avatarBodyPartIds', avatarBodyPartIds);

export default avatarAssetTypeNames;
